import React from 'react'
import PropTypes from 'prop-types'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'
import FitScreenOutlinedIcon from '@mui/icons-material/FitScreenOutlined'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { ToolGroup, ToolDivider, SquareIconButton, ZoomLabel, PageInput, PageText } from './editorChrome'

function ZoomPageToolbar({ zoom, page, pageCount }) {
  return (
    <>
      <ToolGroup role="group" aria-label="Page navigation">
        <SquareIconButton aria-label="Previous page" onClick={() => page.goToPage(page.pageIndex)} disabled={page.pageIndex === 0}>
          <ChevronLeftIcon />
        </SquareIconButton>
        <PageText>Page</PageText>
        <PageInput
          aria-label="Page number"
          value={page.pageDraft ?? String(page.pageIndex + 1)}
          onChange={e => page.setPageDraft(e.target.value)}
          onBlur={() => page.commitPageDraft()}
          onKeyDown={e => {
            if (e.key === 'Enter') page.commitPageDraft()
          }}
        />
        <PageText data-testid="page-count">of {pageCount}</PageText>
        <SquareIconButton aria-label="Next page" onClick={() => page.goToPage(page.pageIndex + 2)} disabled={page.pageIndex >= pageCount - 1}>
          <ChevronRightIcon />
        </SquareIconButton>
      </ToolGroup>
      <ToolDivider />
      <ToolGroup role="group" aria-label="Zoom">
        <SquareIconButton aria-label="Zoom out" onClick={zoom.zoomOut} disabled={!zoom.canZoomOut}>
          <RemoveIcon />
        </SquareIconButton>
        <ZoomLabel data-testid="zoom-level">{zoom.zoomPercent}%</ZoomLabel>
        <SquareIconButton aria-label="Zoom in" onClick={zoom.zoomIn} disabled={!zoom.canZoomIn}>
          <AddIcon />
        </SquareIconButton>
        <SquareIconButton aria-label="Fit to width" onClick={zoom.fitToWidth} active={zoom.isFit ? 'true' : 'false'} aria-pressed={zoom.isFit}>
          <FitScreenOutlinedIcon />
        </SquareIconButton>
      </ToolGroup>
    </>
  )
}

ZoomPageToolbar.propTypes = {
  zoom: PropTypes.shape({
    zoomPercent: PropTypes.number.isRequired,
    isFit: PropTypes.bool.isRequired,
    canZoomIn: PropTypes.bool.isRequired,
    canZoomOut: PropTypes.bool.isRequired,
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
    fitToWidth: PropTypes.func.isRequired
  }).isRequired,
  page: PropTypes.shape({
    pageIndex: PropTypes.number.isRequired,
    pageDraft: PropTypes.string,
    setPageDraft: PropTypes.func.isRequired,
    commitPageDraft: PropTypes.func.isRequired,
    goToPage: PropTypes.func.isRequired
  }).isRequired,
  pageCount: PropTypes.number.isRequired
}

export default ZoomPageToolbar
